import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
class NotFound extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="d-flex  flex-column w-100 align-items-center justify-content-between  ">
        <div className="d-flex justify-content-center align-content-center pt-5 w-75">
          <img
            alt="404"
            src={require('../../content/images/elements/not-found-page.png')}
          />
        </div>

        <div className="d-flex justify-content-center align-items-center w-100 flex-column">
          <div className="d-flex justify-content-center text-muted w-100 font-large font-sm-samll">
            <FormattedMessage id="errorBoundary.oops" />
          </div>
          <div className="d-flex justify-content-center text-muted w-100 font-large font-sm-samll pt-2">
            <FormattedMessage id="errorBoundary.weSearched" />
          </div>
        </div>
      </div>
    );
  }
}

export default NotFound;
